var _desc, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoTransparent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1280,
    height: 1024,
    viewBox: "0 0 1280 1024",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 4.4.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 640 512)",
    id: "background-logo"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillOpacity: 0,
      fillRule: "nonzero",
      opacity: 1
    },
    paintOrder: "stroke",
    x: -640,
    y: -512,
    rx: 0,
    ry: 0,
    width: 1280,
    height: 1024
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.45369486200344 0 0 3.45369486200344 640.5823617588275 512.3327781479016)",
    id: "logo-logo"
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    paintOrder: "stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.9991053922023543 0 0 -2.999105392202354 0 0)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_168183",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -53.958 -39.485)",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 75
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(23,234,217)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(96,120,234)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_168183)",
      fillRule: "nonzero",
      opacity: 1
    },
    paintOrder: "stroke",
    transform: " translate(20.957499999999996, 1.8530000000000015)",
    d: "M 0 0 L 0 -27.442 L -13.546 -27.442 L -4.2829999999999995 -39.485 L 12.043 -39.485 L 12.043 9.264 Z M -53.958 -12.969 L -53.958 35.778999999999996 L -37.632 35.778999999999996 L -28.368 23.736999999999995 L -41.915 23.736999999999995 L -41.915 -3.705 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.9991053922023543 0 0 -2.999105392202354 -0.00029991053924049993 0)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(27,56,170)",
      fillRule: "nonzero",
      opacity: 1
    },
    paintOrder: "stroke",
    transform: " translate(1.8530000000000015, -25.589)",
    d: "M 0 0 L -15.264 0 C -19.424999999999997 0 -22.81 3.385 -22.81 7.546 L -22.81 18.178 L -34.853 8.915 L -34.853 7.546 C -34.853 -3.2719999999999994 -26.083000000000002 -12.043 -15.264000000000003 -12.043 L 9.264 -12.043 Z M -12.969 63.221 L 11.558000000000002 63.221 C 22.377000000000002 63.221 31.147 54.45099999999999 31.147 43.632 L 31.147 42.264 L 19.105 33 L 19.105 43.632 C 19.105 47.793 15.719000000000001 51.178999999999995 11.558 51.178999999999995 L -3.705 51.178999999999995 Z",
    strokeLinecap: "round"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.9211538461538462 0 0 1.9211538461538462 637.0690516626737 506.0617477632861)",
    id: "text-logo-path-group"
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    paintOrder: "stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 0)",
    id: "text-logo-path-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(27,56,170)",
      fillRule: "nonzero",
      opacity: 1
    },
    paintOrder: "stroke",
    transform: " translate(-64.55, 33.11)",
    d: "M 0.57 -0.47 L 0.57 -0.47 L 12.35 -65.74 Q 12.45 -66.12 12.82 -66.12 L 12.82 -66.12 L 26.6 -66.12 Q 26.98 -66.12 27.07 -65.74 L 27.07 -65.74 L 38.38 -0.47 Q 38.48 0 38 0 L 38 0 L 27.46 0 Q 27.07 0 26.98 -0.47 L 26.98 -0.47 L 25.93 -7.41 L 13.02 -7.41 L 11.97 -0.47 Q 11.88 0 11.5 0 L 11.5 0 L 0.95 0 Q 0.57 0 0.57 -0.47 Z M 19.19 -44.27 L 14.92 -17.57 L 24.04 -17.57 L 20.14 -44.27 L 19.57 -47.79 L 19.19 -44.27 Z M 59.95 0.95 L 59.95 0.95 Q 54.72 0.95 50.49 -1.66 Q 46.27 -4.28 43.8 -8.64 Q 41.33 -13.02 41.33 -18.43 L 41.33 -18.43 L 41.42 -48.07 Q 41.42 -53.3 43.84 -57.62 Q 46.27 -61.94 50.49 -64.55 Q 54.72 -67.17 59.95 -67.17 L 59.95 -67.17 Q 65.17 -67.17 69.35 -64.6 Q 73.53 -62.04 76 -57.71 Q 78.47 -53.39 78.47 -48.07 L 78.47 -48.07 L 78.47 -43.7 Q 78.47 -43.32 78.09 -43.32 L 78.09 -43.32 L 67.45 -43.32 Q 67.07 -43.32 67.07 -43.7 L 67.07 -43.7 L 67.07 -48.07 Q 67.07 -51.2 65.03 -53.48 Q 62.98 -55.77 59.95 -55.77 L 59.95 -55.77 Q 56.52 -55.77 54.72 -53.44 Q 52.91 -51.11 52.91 -48.07 L 52.91 -48.07 L 52.91 -18.43 Q 52.91 -14.92 54.96 -12.73 Q 57 -10.54 59.95 -10.54 L 59.95 -10.54 Q 62.98 -10.54 65.03 -12.97 Q 67.07 -15.39 67.07 -18.43 L 67.07 -18.43 L 67.07 -22.8 Q 67.07 -23.18 67.45 -23.18 L 67.45 -23.18 L 78.19 -23.18 Q 78.56 -23.18 78.56 -22.8 L 78.56 -22.8 L 78.56 -18.43 Q 78.56 -13.02 76.05 -8.64 Q 73.53 -4.28 69.35 -1.66 Q 65.17 0.95 59.95 0.95 Z M 96.62 0 L 85.88 0 Q 85.5 0 85.5 -0.47 L 85.5 -0.47 L 85.69 -65.74 Q 85.69 -66.12 86.07 -66.12 L 86.07 -66.12 L 97.66 -66.12 Q 98.04 -66.12 98.33 -65.74 L 98.33 -65.74 L 106.97 -53.2 L 115.62 -65.74 Q 115.9 -66.12 116.28 -66.12 L 116.28 -66.12 L 127.97 -66.12 Q 128.34 -66.12 128.34 -65.74 L 128.34 -65.74 L 128.53 -0.47 Q 128.53 0 128.16 0 L 128.16 0 L 117.42 0 Q 117.04 0 117.04 -0.47 L 117.04 -0.47 L 116.94 -48.92 L 106.97 -34.48 L 97.09 -48.92 L 97 -0.47 Q 97 0 96.62 0 L 96.62 0 Z",
    strokeLinecap: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTransparent);
export default __webpack_public_path__ + "static/media/logo_transparent.3d8ce54a2da931f2996460972936847c.svg";
export { ForwardRef as ReactComponent };